module.exports = __webpack_public_path__ + "static/media/heartbeat.fe514a84.svg";